import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sign-up-form" }
const _hoisted_2 = { class: "body-text text-align-center registration-warning" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Don’t have an account yet? ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "heading h1 text-align-center page-title" }, " Login into your Augmentify account ", -1)
const _hoisted_5 = { class: "form-wrapper" }
const _hoisted_6 = { class: "input-group" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "forgot-password-container" }, [
  /*#__PURE__*/_createElementVNode("a", { class: "secondary-link" }, " Forgot password? ")
], -1)

import { ref } from "vue";
import { NInput, NButton, NDivider, NForm, NFormItem, NIcon, NText, FormInst } from 'naive-ui'
import { Google as GoogleIcon } from '@vicons/fa'
import { loginRules } from "@/ts/formValidationRules"

import { useAuthLoginStore } from "@/stores/auth/login.store";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginForm',
  setup(__props) {

const authLoginStore = useAuthLoginStore()

const formRef = ref<FormInst | null>(null)

const formData = ref<{ email: string, password: string }>({
  email: '',
  password: ''
})

const handleLogin = () => {
  formRef.value?.validate((errors) => {
    if (!errors) {
      authLoginStore.login(formData.value)
    }
  })
}

const validationStatus = (value : number) => value === 2 ? 'error' : 'success';

const errorMessage = (value : number, field : string) => {
  if(value === 2) {
    return (authLoginStore.errors?.errors?.[field] ?? []).shift()
  }

  return '';
}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_router_link, {
        class: "simple-link",
        to: "/sign-up"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Register here")
        ]),
        _: 1
      })
    ]),
    _hoisted_4,
    (_unref(authLoginStore).errors?.message === 'Unauthorized')
      ? (_openBlock(), _createBlock(_unref(NText), {
          key: 0,
          type: "error",
          class: "error-message text-center"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Incorrect email or password ")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_unref(NForm), {
        ref_key: "formRef",
        ref: formRef,
        model: formData.value,
        rules: _unref(loginRules)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_unref(NFormItem), {
              path: "email",
              label: "Email",
              feedback: errorMessage(_unref(authLoginStore).status, 'email'),
              "validation-status": validationStatus(_unref(authLoginStore).status)
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(NInput), {
                  value: formData.value.email,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.email) = $event)),
                  size: "large",
                  round: "",
                  placeholder: "Yourname@email.com",
                  class: "form-input",
                  onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 8, ["feedback", "validation-status"]),
            _createVNode(_unref(NFormItem), {
              path: "password",
              label: "Password",
              feedback: errorMessage(_unref(authLoginStore).status, 'password'),
              "validation-status": validationStatus(_unref(authLoginStore).status)
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(NInput), {
                  value: formData.value.password,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.password) = $event)),
                  size: "large",
                  round: "",
                  placeholder: "Password",
                  class: "form-input",
                  type: "password",
                  "show-password-on": "click"
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 8, ["feedback", "validation-status"])
          ]),
          _hoisted_7,
          _createVNode(_unref(NButton), {
            class: "button",
            size: "large",
            onClick: _withModifiers(handleLogin, ["prevent"]),
            loading: _unref(authLoginStore).status === 0
          }, {
            default: _withCtx(() => [
              _createTextVNode(" LOGIN ")
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ])
  ]))
}
}

})